import React, { Component, ChangeEvent } from 'react';
import { FieldGroup } from '../components/FieldGroup';
import { Button } from 'react-bootstrap';
import AuthenticationStore from '../stores/AuthenticationStore';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router';


type LoginState = {
  email : string,
  password : string
}

type LoginProps = {
  authenticationStore : AuthenticationStore
}

@inject((allStores : any) => {
  return {
    authenticationStore: allStores.authenticationStore as AuthenticationStore
  };
})
@observer
class Login extends Component<LoginProps, LoginState> {
  state : LoginState = {
    email: '',
    password: ''
  };
  
  updateField(name : string, event : ChangeEvent<EventTarget>) {
    const target = event.target as HTMLInputElement;
    this.setState({
      [name]: target.value
    } as LoginState);
  }

  authenticateAccount = () => {
    this.props.authenticationStore.authenticateAccount(this.state);
  }

  render() {
    const { authenticated, loginErrorMessage } = this.props.authenticationStore;
    if (authenticated)
      return <Redirect to='/'/>

    return (
      <form>
        <div className="container">
          <h1 className="text-center">Login</h1>
          <hr></hr>
          <div className="well col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6">
            <FieldGroup
              id='loginEmail'
              type='text'
              label='Email'
              onChange={this.updateField.bind(this, 'email')}
              value={this.state.email}
            />
            <FieldGroup
              id='loginPassword'
              type='password'
              label='Password'
              onChange={this.updateField.bind(this, 'password')}
              value={this.state.password}
            />
            <Button bsStyle='primary' onClick={this.authenticateAccount}>Login</Button>
            { 
              loginErrorMessage === null ? '' : <h5 className='text-center'>{loginErrorMessage}</h5>
            }
          </div>
        </div>
      </form>
    );
  }
};

export { Login };